/**
 * Mock 模块：heart_voyage_stage_claim
 * @see mockMd/heart_voyage_stage_claim.md
 * 单行领取弹窗 VRT：rewards.length = 3（稿面一行 3 格）
 */
import {storiesReward} from '../components/BlindBoxRewardModal/stories-images'
import type {HeartVoyageStageClaimData} from '../types'

/** @see mockMd/heart_voyage_stage_claim.md */
export const HeartVoyageStageClaimMock: HeartVoyageStageClaimData = {
  err_msg: '',
  rewards: [
    {
      id: 9010,
      name: 'Event Wall of Honor',
      icon: storiesReward,
      desc: 'Event Wall of Honor*2day',
      value: 2,
      num: 1,
      reward_type: 1,
    },
    {
      id: 9011,
      name: 'Event Wall of Honor',
      icon: storiesReward,
      desc: 'Event Wall of Honor*2day',
      value: 2,
      num: 1,
      reward_type: 1,
    },
    {
      id: 9012,
      name: 'Event Wall of Honor',
      icon: storiesReward,
      desc: 'Event Wall of Honor*2day',
      value: 2,
      num: 1,
      reward_type: 1,
    },
  ],
}
